
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import type { NotificationSeverity, Notification } from '../../types/notification.types';
import { NotificationContext } from './NotificationContext';

export const NotificationProvider = ({ children }: { children: React.ReactNode }) => {

    const [notifications, setNotifications] = React.useState<Notification[]>([]);

    const showNotification = (message: string, severity: NotificationSeverity = "info") => {
        const id = Date.now();
        setNotifications(prev => [...prev, { id, message, severity }]);
    };

    const removeNotification = (id: number) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {notifications.map((n) => (
                <Snackbar
                    key={n.id}
                    open
                    autoHideDuration={5000}
                    onClose={() => removeNotification(n.id)}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}>
                    <Alert
                        severity={n.severity}
                        variant="filled"
                        onClose={() => removeNotification(n.id)}
                    >
                        {n.message}
                    </Alert>
                </Snackbar>
            ))}
        </NotificationContext.Provider>
    );
};